import { render } from "./IntercomDescribe.vue?vue&type=template&id=c512c150&scoped=true"
import script from "./IntercomDescribe.vue?vue&type=script&lang=js"
export * from "./IntercomDescribe.vue?vue&type=script&lang=js"

import "./IntercomDescribe.vue?vue&type=style&index=0&id=c512c150&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c512c150"]])

export default __exports__